import { render } from "./IndexArrivalDeclarationStatusPage.vue?vue&type=template&id=4b7d38a6"
import script from "./IndexArrivalDeclarationStatusPage.vue?vue&type=script&lang=js"
export * from "./IndexArrivalDeclarationStatusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__